import Cookies from 'js-cookie';
// 全局定义
import _methods from './common/method';

// 工具方法
import fn from './util/fn';
import util from './util/common';
import {generateCallback, implementCallback} from './util/appCallback';
import invoking from './util/invoking';
import URI from 'jsuri';

// 接口
import mamaAudio from './api/audio';
import webViewMethods from './api/webview';
import deviceMethods from './api/device';
import imageMethods from './api/image';
import recordMethods from './api/record';
import payMethods from './api/pay';
import storageMethods from './api/storage';
import shareMethods from './api/share';
import menuMethods from './api/menu';
import locationMethods from './api/location';
// 初始注入
import './common/Mama';

/**
 * @param url
 * @returns {object}
 */
const getQInfo = url => {
    let type = '';
    let qid = '';
    const arr = url.split('?');
    const re = /\/(topic|group)\/(\d+)/;
    const userHomeReg = /www.mama.cn\/u\/(\d+)/;
    if (re.test(url) && url.includes('//q.mama.cn/')) {
        const arrMatch = url.match(re);
        if (arrMatch && arrMatch.length > 2) {
            type = arrMatch[1];
            qid = arrMatch[2];
        }
    } else if (arr.length > 1) {
        const strParams = arr[1];
        const reGroup = /(^|&)topic_id=(\d+)(&|$)/;
        const reTopic = /(^|&)post_id=(\d+)(&|$)/;
        const reUserHome = /(^|&)friend_uid=(\d+)(&|$)/;
        if (url.includes('//papi.mama.cn/wap/group/share_topic') && reGroup.test(strParams)) {
            type = 'group';
            const arrMatch = strParams.match(reGroup);
            if (arrMatch && arrMatch.length > 2) {
                qid = arrMatch[2];
            }
        } else if (url.includes('//papi.mama.cn/wap/post/share') && reTopic.test(strParams)) {
            type = 'topic';
            const arrMatch = strParams.match(reTopic);
            if (arrMatch && arrMatch.length > 2) {
                qid = arrMatch[2];
            }
        } else if (url.includes('//papi.mama.cn/wap/friend_home_page/share') && reUserHome.test(strParams)) {
            type = 'userHome';
            const arrMatch = strParams.match(reUserHome);
            if (arrMatch && arrMatch.length > 2) {
                qid = arrMatch[2];
            }
        }
    } else if (userHomeReg.test(url)) {
        const marcher = url.match(userHomeReg);
        if (marcher && marcher.length > 1) {
            qid = marcher[1];
            type = 'userHome';
        }
    }
    return {
        type,
        qid
    };
};

/**
 * setMethod
 * @param name
 */
let appMethods = Object.assign({}, _methods);
const setMethod = name => {
    if (runMethodByName(name)) {
        MJSSDK[name] = option => {
            let res = {
                code: 0,
                data: option
            };
            res = Object.assign({}, option, res);
            const json = JSON.stringify(res);
            runMethodByName(name, 'run', json);
        };
    }
};

/**
 * setAllMethods
 */
const setAllMethods = () => {
    for (const i in appMethods) {
        if (Object.prototype.hasOwnProperty.call(appMethods, i)) {
            if (MJSSDK[i]) {
                // console.error('already define ' + i);
            } else {
                Number(
                    (function (name) {
                        setMethod(name);
                    })(i)
                );
            }
        }
    }
};

/**
 * runMethodByName
 * @param name {String}
 * @param type {String} run
 * @param option {String}
 * @returns {Function|undefined}
 */
const runMethodByName = (name, type, option) => {
    let func, i, _class, obj;

    if (MJSSDK.UA.android) {
        i = appMethods[name];
        if (i) {
            _class = i.androidClass ? i.androidClass : 'android';
            obj = window[_class];
            if (!obj) {
                obj = window['android'];
            }
            func = obj[name];
            if (!func) {
                func = undefined;
            }
        } else {
            func = undefined;
        }
    } else {
        obj = window;
        func = obj[name];
    }
    /*
     * 两个 try 确保 app 执行的错误捕获
     */
    if (type === 'run') {
        try {
            obj[name](option);
        } catch (e1) {
            try {
                obj[name]();
            } catch (e2) {
                // window.alert(`e1:${  e1  },e2:${  e2}`);
                console.error(`e1:${e1},e2:${e2}`);
            }
        }
        return false;
    }
    return func;
};

const MJSSDK = {
    init(config = {}) {
        this.config = Object.assign(this.config, config);
        if (this.UA.gzm) {
            const viewportMeta = window.document.querySelector('meta[name="viewport"]')
            if (viewportMeta) {
                const content = viewportMeta.getAttribute('content')
                const contentList = content ? content.split(',') : []
                const viewportFitIndex = contentList.findIndex(v => v.includes('viewport-fit=cover'))
                if (viewportFitIndex > -1) {
                    contentList.splice(viewportFitIndex, 1)
                    viewportMeta.setAttribute('content', contentList.join(','))
                }
            }
        }
        if (
            (this.UA.pregnancyhelper && this.compareVer('6.7') > -1) ||
            (this.UA.mmq && this.compareVer('8.7') > -1) ||
            this.UA.mmgoods
        ) {
            window.Mama.shareResult = function (res) {
                if (window.Mama.shareResult[res.data.methodName]) {
                    window.Mama.shareResult[res.data.methodName](res);
                }
            };
        }
        if (!window.MMAPP && this.UA.mamaApp && this.UA.ios) {
            // 处理 ios cookie 丢失问题
            // hook cookie - 将 native 中的 cookie 同步到 webview
            let userId = Cookies.get('user_id');
            this.invocation({
                action: 'getLoginCookie',
                data: {
                    name: this.config.cookieName
                },
                success: function (res) {
                    if (!userId && res.cookie && res.cookie.length) {
                        util.fixCookie([...res.cookie]);
                        userId = Cookies.get('user_id');
                        // 只有设置成功，才进行刷新。兼容低版本 app 返回的数据格式不一致
                        if (userId) {
                            // action 回调非同步执行，至少要刷新一次
                            util.enforceRefresh();
                        }
                    }
                }
            });
            // hook cookie - document.cookie 同步到 native（WKWebView cookie 同步到 NSHTTPCookieStorage）
            // 不在 app 在注入，放在 MJSSDK
            try {
                const cookieDesc =
                    Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
                    Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
                if (cookieDesc && cookieDesc.configurable) {
                    Object.defineProperty(document, 'cookie', {
                        configurable: true,
                        enumerable: true,
                        get: function () {
                            // console.log('getCookie');
                            return cookieDesc.get.call(document);
                        },
                        set: function (val) {
                            // console.log('setCookie');
                            cookieDesc.set.call(document, val);
                            MJSSDK.invocation({
                                action: 'setCookie',
                                data: {
                                    cookie: val
                                }
                            });
                        }
                    });
                }
            } catch (e) {
                console.log('this browser does not support reconfigure document.cookie property', e);
            }
        }

        return this;
    },
    mount() {
        this.config = {
            cookieName: ['user_id', 'xkey']
        };
        this.UA = fn.getUA();
        this.defaultBaiduMapAk = 'pumv736L7ZnqDmp38XyA3ACXzcLGe03O';
        fn.fixMethods();
        setAllMethods();
        this.init();
    },
    getApiList() {
        return Object.keys(appMethods);
    },
    /**
     * checkApiByName
     * @param name {string} {"string"}
     * @returns {boolean}
     */
    checkApiByName(name) {
        return Boolean(runMethodByName(name));
    },
    /**
     * compareVer
     * @param ver
     * @param compareVer
     * @returns {number}
     */
    compareVer(ver, compareVer) {
        if (arguments.length === 1) {
            compareVer = ver;
            ver = this.UA.appVer;
        }
        if (!(compareVer && ver)) {
            throw Error('can`t compare null ver');
        }
        const compareVerArr = compareVer.split('.'),
            verArr = ver.split('.'),
            length = compareVerArr.length > verArr.length ? compareVerArr.length : verArr.length;
        let result = 0,
            compareVerItem,
            verItem;

        for (let i = 0; i < length; i++) {
            if (!compareVerArr[i] && verArr[i]) {
                result = 1;
                break;
            } else if (!verArr[i] && compareVerArr[i]) {
                result = -1;
                break;
            } else {
                compareVerItem = parseInt(compareVerArr[i]);
                verItem = parseInt(verArr[i]);
                if (verItem < compareVerItem) {
                    result = -1;
                    break;
                } else if (verItem === compareVerItem) {
                    result = 0;
                } else {
                    result = 1;
                    break;
                }
            }
        }
        return result;
    },
    // 扩展旧方法
    extend(obj) {
        appMethods = Object.assign(appMethods, obj);
        for (const i in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, i)) {
                Number(
                    (function (name) {
                        setMethod(name);
                    })(i)
                );
            }
        }
    },
    // 通用 action
    invocation(option) {
        if (option.action) {
            invoking({
                action: option.action,
                version: option.version || '',
                data: option.data || {},
                option
            });
        }
    },
    // 是否显示播放器浮层快捷入口
    showAudioPlayerEntry(option = {}) {
        invoking({
            action: 'showAudioPlayerEntry',
            data: {
                isShow: option.isShow || false
            },
            option
        });
    },
    // 检测是否安装 APP
    hasApp(option) {
        if (this.isInstalledApp) {
            const globalMethodName = generateCallback(option, res => {
                return {
                    code: 0,
                    data: {
                        isInstall: ~~res
                    }
                };
            });
            this.isInstalledApp({
                packages: option.packages || '',
                scheme: `${option.scheme}://` || '',
                jsmethod: globalMethodName
            });
        }
    },
    // 打开 APP
    openApp(option) {
        if (this.openInstalledApp) {
            this.hasApp({
                packages: option.packages || '',
                scheme: `${option.scheme}://` || '',
                success: res => {
                    if (res.isInstall) {
                        this.openInstalledApp({
                            packages: option.packages || '',
                            scheme: `${option.scheme}://` || ''
                        });
                        implementCallback({code: 0}, option);
                    } else {
                        implementCallback({code: -1}, option);
                    }
                }
            });
        }
    },
    // 去登录
    openLogin(option = {}) {
        // app 内唤起原生登录
        const sHref = window.location.href;
        if (this.UA.mamaApp) {
            if (this.openMamaLogin) {
                const globalMethodName = generateCallback(option, res => {
                    // 原生登录回调
                    // console.log('!passport获取的code: ' + res.code);
                    const code = ~~res.code !== 0 ? -1 : 0;
                    const result = {
                        code: code,
                        data: res.data
                    };
                    if (code === 0) {
                        // 只要有 cookie 返回就更新
                        if (res.data.cookie && res.data.cookie.length) {
                            util.fixCookie([...res.data.cookie]);
                        }
                        // res.data.callback => 'userMamaLoginCallBack'
                        if (MJSSDK.userMamaLoginCallBack) {
                            MJSSDK.userMamaLoginCallBack();
                        }
                        if (option.enforceRefresh === false) {
                            // 不刷新也不跳转
                        } else if (option.callbackUrl && option.callbackUrl !== window.location.href) {
                            // 自定义回调跳转
                            if (res.data.code) {
                                window.location.href = new URI(option.callbackUrl)
                                    .replaceQueryParam('code', res.data.code)
                                    .toString();
                            } else {
                                window.location.href = option.callbackUrl;
                            }
                        } else {
                            // 刷新当前页面
                            if (res.data.code) {
                                util.enforceRefresh({code: res.data.code});
                            } else {
                                util.enforceRefresh();
                            }
                        }
                    } else {
                        console.error('APP 登录回调异常！');
                        if (option.enableErrorLoginGoBack) {
                            util.goBack();
                        }
                    }
                    return result;
                });
                this.openMamaLogin({
                    type: 0,
                    jsmethod: globalMethodName
                });
            } else {
                window.location.href = 'q://loginwap';
            }
        } else if (this.UA.wx && !option.disableWxAuthorize) {
            // 微信授权登录
            const url = util.replaceQueryParam(
                `//passport.mama.cn/wapweixinlogin?service=${encodeURIComponent(option.callbackUrl || sHref)}`,
                option.wapWXParam
            );
            window.location.replace(url);
        } else {
            const url = `//passport.mama.cn/wapindex?service=${encodeURIComponent(option.callbackUrl || sHref)}`;
            window.location.replace(url);
        }
    },
    // 关闭离线包功能
    disableOffline() {
        MJSSDK.invocation({
            action: 'disableOffline',
            success() {
                if (window.offlineAjaxHookConfig) {
                    window.offlineAjaxHookConfig.enableAjaxHook(false);
                }
            }
        });
    },
    /**
     * 将 url 在孕育 app 下转换为 q 协议
     * @param {string} url
     * @returns {string}
     */
    getQPath(url = '') {
        if (!url || typeof url !== 'string') {
            return '';
        }
        let path = url;
        if (!MJSSDK.UA.pregnancyhelper) {
            return path;
        }
        const {type, qid} = getQInfo(url);
        if (!qid || !type) {
            return path;
        }
        const paths = {
            groupOld: `q://forum?siteflag=mmq&fid=${qid}&tyq=0`,
            topicOld: `q://thread?tid=${qid}&fid=1&siteflag=mmq`,
            group: `q://topicDetail?topicId=${qid}`,
            topic: `q://soft_post_detail?post_id=${qid}`,
            userHome: `q://userHome?uid=${qid}`,
            userHomeOld: `q://userHome?uid=${qid}`
        };
        if (MJSSDK.compareVer('9.5') >= 0) {
            path = paths[type];
        } else {
            path = paths[`${type}Old`];
        }
        return path;
    },
    /**
     * 安卓二级导航使用，webview 获得 滑动控制权，安卓不允许拦截 touch 事件
     * @param {*} option 
     */
    enableInterceptTouchEvent(option = {}) {
        if (MJSSDK.UA.android) {
            invoking({
                action: 'requestDisallowInterceptTouchEvent',
                data: true,
                option
            });
        }
    },
    /**
     * 安卓二级导航使用，webview 释放 滑动控制权，安卓拦截 touch 事件
     * @param {*} option 
     */
    disableInterceptTouchEvent(option = {}) {
        if (MJSSDK.UA.android) {
            invoking({
                action: 'requestDisallowInterceptTouchEvent',
                data: false,
                option
            });
        }
    },
};
MJSSDK.mount();
// 代理模块方法
Object.assign(
    MJSSDK,
    webViewMethods,
    deviceMethods,
    imageMethods,
    recordMethods,
    storageMethods,
    menuMethods,
    shareMethods,
    payMethods,
    locationMethods
);

if (!window.MamaJSBridge) {
    window.MamaJSBridge = MJSSDK;
}
if (!window.MJSSDK) {
    window.MJSSDK = MJSSDK;
}
MJSSDK.mamaAudio = mamaAudio;

/**
 * 页面作为二级导航时，一些方法 / action 禁用其效果
 */
MJSSDK.appSecondTab = false;
(function hackWhenSecondTab (){
    const uri = new URI(window.location.href);
    const appentrance = uri.getQueryParamValue('appentrance') || '';
    if (appentrance !== 'second_tab') {
        return;
    }
    MJSSDK.appSecondTab = true;
    function hackInvalidMethods() {
        // method
        const invalidMethods = [
            'setFullscreenWebview', 'setNavBackButtonColor', 'setNavCloseButtonColor',
            'setNavTitleColor', 'setNavBGColor'
        ];
        const noop = () => {};
        invalidMethods.forEach(name => {
            MJSSDK[name] = noop;
        });
    }
    function hackInvalidActions() {
        // action
        const invalidActions = [
            'changeNavBGColor', 'changeNavTitleColor', 'changeNavBackButtonColor',
            'changeNavCloseButtonColor', 'changeNavBGImg', 'changeFullScreenMode',
            'changeNavStatusList', 'changeNavBarVisibility'
        ];
        const originInvocation = MJSSDK.invocation;
        MJSSDK.invocation = function(...args) {
            const options = args[0];
            if (options && invalidActions.includes(options.action)) {
                return;
            }
            originInvocation.apply(MJSSDK, args);
        }
    }
    function hackTouchEvent() {
        /**
         * 判断元素是否可以滚动
         * @param el {Element} 元素
         */
        function elScrollable(el) {
            const isIncludeOverflowValues = (styleValue) => {
             
                return ['auto', 'scroll', 'overlay'].includes(styleValue);
            };
            const isScrollX = el.scrollWidth > el.clientWidth;
            // 先过滤不符合 scrollHeight > clientHeight 或 scrollWidth > clientWidth 的情况，不用频繁调用 window.getComputedStyle
            if (!isScrollX) {
                return false;
            }
            const elStyle = window.getComputedStyle(el);
            return isScrollX && isIncludeOverflowValues(elStyle.overflowX);
        }
        /**
         * 向上查找可以滚动的元素
         * @param start {Element} 开始元素
         * @param end {Element} 结束元素
         */
        function findUpScrollableElement(start, end = document.body ) {
            let result = null;
            let parentEl = start;
            while (true) {
                if (!parentEl || (parentEl !== end && parentEl.contains(end))) {
                    break;
                }
                if (elScrollable(parentEl)) {
                    result = parentEl;
                    break;
                }
                parentEl = parentEl.parentElement;
            }
            return result;
        }
        let isBeingDrag = false;
        document.addEventListener('touchstart', (event) => {
            if (!findUpScrollableElement(event.target)) {
                return;
            }
            isBeingDrag = true;
            MJSSDK.enableInterceptTouchEvent();
        });
        document.addEventListener('touchend', () => {
            if(isBeingDrag){
                MJSSDK.disableInterceptTouchEvent();
                isBeingDrag = false
            }
        });
    }

    hackInvalidMethods();
    hackInvalidActions();
    hackTouchEvent();
})();

export default MJSSDK;
